/** Ticket wording shared by the panel, the new-ticket dialog and the chat's draft card (TMMAPP-0142 U2). */
import type { TFunction } from 'i18next';
import { errorCopy } from '@/api/errorCopy';
import { attachmentErrorCopy } from '../composer/attachmentRules';
import { ErrorCodes, isApiError } from '@/api/errors';
import type { TicketType } from '@/api/tickets';

export const TICKET_TYPE_KEYS: Record<TicketType, string> = {
  SUPPORT_CASE: 'support.tickets.type.SUPPORT_CASE',
  FEATURE_REQUEST: 'support.tickets.type.FEATURE_REQUEST',
};

/**
 * Why a ticket couldn't be filed or a reply sent: the day's limit (`429`) in its own words, a file
 * over the limits by `limitKind`, else the code's catalog copy.
 */
export function ticketErrorCopy(t: TFunction, error: unknown, locale: string): string {
  if (isApiError(error) && (error.status === 429 || error.code === ErrorCodes.RATE_LIMITED)) {
    return t('support.tickets.rateLimited');
  }
  if (
    isApiError(error) &&
    (error.code === ErrorCodes.ASSISTANT_ATTACHMENT_TOO_LARGE ||
      error.code === ErrorCodes.ASSISTANT_ATTACHMENT_NOT_FOUND)
  ) {
    return attachmentErrorCopy(t, error, locale, 'support.tickets.fileError');
  }
  return errorCopy(t, error, 'support.tickets.fileError');
}
